import { render } from "./Heading.vue?vue&type=template&id=97fae0c4"
const script = {}

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__